import { Link } from "react-router-dom";
import { useAuthStore } from "../stores/auth";
import { Card, PageHeader } from "../components/Layout";

export default function DashboardPage() {
  const me = useAuthStore((s) => s.me);
  const tiles = [
    { to: "/dictionary", title: "Diccionario", desc: "Explora variables y etiquetas de cada formulario." },
    { to: "/descriptive", title: "Informe descriptivo", desc: "Selecciona variables y obtén frecuencias con margen de error." },
    { to: "/weighting", title: "Ponderación", desc: "Ajusta la muestra por género, distrito, etc. (post-estratificación)." },
    { to: "/crosstabs", title: "Crosstabs", desc: "Tablas cruzadas con margen de error y Chi²." },
    { to: "/regression", title: "Regresión", desc: "OLS / Logit / Probit / Poisson / RLM con diagnóstico." },
    { to: "/timeseries", title: "Series de tiempo", desc: "Compara encuestas y proyecta con ARIMA/Holt-Winters/ETS." },
    { to: "/bootstrap", title: "Bootstrap", desc: "IC por percentil y BCa." },
    { to: "/reports", title: "Informes", desc: "Exporta datos y genera PDF con conclusión IA." },
  ];

  return (
    <div className="p-4 sm:p-6 max-w-6xl mx-auto">
      <PageHeader
        title={`Hola, ${me?.email ?? ""}`}
        subtitle={`Rol: ${me?.role} · Visor estadístico de encuestas ODK`}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to}>
            <Card className="hover:border-marca transition-colors cursor-pointer">
              <div className="text-marca font-semibold">{t.title}</div>
              <div className="text-sm text-tinta-3 mt-1">{t.desc}</div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
